import React, { useState } from 'react'
import { Button, Tab } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import { ListLevel, LevelForm } from "../../../components/Admin/Level";
import "./Level.scss";

export function Level() {

  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListLevel reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="level-page">
        <Button className="level-page__add" primary onClick={onOpenCloseModal}>
          Nuevo nivel
        </Button>
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title="Crear nivel">
        <LevelForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  )
}